import { render, staticRenderFns } from "./head-menu.vue?vue&type=template&id=16517db4&lang=pug&"
import script from "./head-menu.vue?vue&type=script&lang=js&"
export * from "./head-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports